export const MANUAL_TAX_TYPES = ['nonRefTaxes', 'paidTaxes', 'refundableTaxes'];